
import { mapGetters } from 'vuex'

export default {
  components: {},
  layout(context) {
    return 'fullscreen'
  },

  data() {
    return {
      taster_access: false,
   
    }
  },

async mounted(){
      /* eslint-disable */
  if(process.client){
    if(window.location.hash==='#extensions'){
      this.$router.push('/my-account/dashboard/')
    }
  };
    /* eslint-enable */
  if(this.$route.query.session && this.$route.query.userid){
    await this.$store.dispatch('user/login', {jwt:this.$route.query.session,userid:this.$route.query.userid})

    this.$router.push('/my-account/dashboard/')
  }
},
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      orderId: 'cart/getOrderId',
      //  label: 'cart/getPriceLabel',
    }),
 
}
